import { render } from "./NavItemComponent.vue?vue&type=template&id=3c8a7b27&scoped=true"
import script from "./NavItemComponent.vue?vue&type=script&lang=js"
export * from "./NavItemComponent.vue?vue&type=script&lang=js"

import "./NavItemComponent.vue?vue&type=style&index=0&id=3c8a7b27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8a7b27"]])

export default __exports__